<template>
    <div class="results-box">
        <h1>Business Outcome</h1>
        <medal :medalType="label" />
        <p v-html="desc"></p>
    </div>
</template>
<script>
    import { mapGetters, mapActions } from "vuex"
    import Medal from '@/components/Medal.vue'
    
    export default{
        name : "BusinessRibbonFeedback",
        components: {
            'medal' : Medal,
        },
        data(){
            return {
                rbn : "",
                desc : "",
                overview : "",
                label: ""
            }
        },
        mounted(){
            this.setRibbon()
        },
        computed : {
            ...mapGetters([
                "playerTotal",
                "getScoring",
                "getBusinessResult"
            ])
        },
        methods : {
            setRibbon(){
                const cat     = this.getBusinessResult
                const content = this.getScoring.business.options[ cat ]
                this.rbn   = content.source
                this.label = content.label
                this.desc  = content.description
            }
        }
    }
</script>